export interface SearchFormat {
  formatNameFilter?: FormatTextFilter;
  formatKeyFilter?: FormatTextFilter;
  specificationTypeKeys?: string[];
  specificationKeys?: string[];
  page: SearchFormatPage;
}

export interface FormatTextFilter {
  value: string;
  matchMode?: FormatTextFilterMatchMode;
  ignoreCase?: boolean;
}

export interface SearchFormatPage {
  page: number;
  size: number;
  sortBy?: string;
  sortDirection?: string;
}

export enum FormatTextFilterMatchMode {
  CONTAINS = 'CONTAINS'
}
